module.exports = __webpack_public_path__ + "static/media/karta-duzej-rodziny.c8db79cd.png";